<script>

    import { toast } from 'bulma-toast'
    import { userStore, accountsStore, modalStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import AccountsService from '../$services/accounts.service'
    import DateMethods from '../$methods/date.methods'
    import NumeralMethods from '../$methods/numeral.methods'
    import TranslateMethods from '../$methods/translate.methods'

    import Select from '../$components/select.svelte'
    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'
    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    export let all = false

    let metadata = {}
    let loading = false
    let reportLoading = false
    let element = null
    let query = {
        page: 0,
        find: null,
    }

    $: skeletonCols = all ? 8 : 7

    getAccounts()

    async function getAccounts() {

        if(all)
            query.admin = true
        else
            query.userId = $userStore._id

        loading = true
        const resp = await AccountsService.getAccounts(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        accountsStore.set(resp.data.accounts)
        metadata = resp.data.metadata
    }

    async function getAccountsReport() {

        reportLoading = true
        const blob = await AccountsService.getAccountsReport()
        reportLoading = false

        if(!blob)
            return toast({message: 'Error al descargar el reporte', type: 'is-danger'})

        element.download = 'cuentas.xlsx'
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} href="/" style="display: none;">.</a>

<Table
    items={ $accountsStore.length }
    total={ metadata.total }
    { loading }
    { skeletonCols }
    bind:metadata
    bind:page={ query.page }
    on:change={ getAccounts }
>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ query.find } on:enter={ getAccounts } />
            {#if all && isPermission($adminStore, 'TracingsView.Account.Report')}
                <Form on:submit={getAccountsReport} loading={reportLoading}>
                    <Button type="submit" icon="file-excel" text="Descargar reporte" loading={reportLoading} />
                </Form>
            {/if}
            {#if !all && isPermission($adminStore, 'UsersView.Account.Create')}
                <ButtonModal modalId="account_create_modal" text="Agregar" icon="plus" />
            {/if}
        </div>
        <div class="header-actions">
            <Select bind:value={ query.status } on:change={ getAccounts }
                text="Estatus de pago"
                size="small"
                options={all ? [
                    {value: 'pending', text: 'Pendiente'},
                    {value: 'paid', text: 'Pagado'},
                ] : [
                    {value: 'pending', text: 'Pendiente'},
                    {value: 'paid', text: 'Pagado'},
                    {value: 'free', text: 'Gratis'},
                ]}
            />
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            {#if all}
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-user"></i></span>
                        <span>Usuario</span>
                    </span>
                </th>
            {/if}
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-clipboard-check"></i></span>
                    <span>Estatus</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-money-bill"></i></span>
                    <span>Pago</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-chart-line"></i></span>
                    <span>Límite</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-shipping-fast"></i></span>
                    <span>Envíos</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar"></i></span>
                    <span>Corte</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $accountsStore as account, index}
            <tr>
                <td><span>{ metadata?.items != null ? (metadata.items * (query.page ?? 0)) + (index + 1) : index + 1 }</span></td>
                {#if all}
                    <td>
                        <div class="td-stack">
                            <div>{ account.user.name }</div>
                            <small>{ account.user.email }</small>
                        </div>
                    </td>
                {/if}
                <td>{ DateMethods.isAfter(account.expired)? 'Activo' : 'Expiró' }</td>
                <td>{ TranslateMethods.get(account.status) }</td>
                <td>{ account.limit? NumeralMethods.cash(account.limit) : 'Sin limite' }</td>
                <td>{ account.shipments.length }</td>
                <td>{ DateMethods.dateLarge(account.expired) }</td>
                <td>
                    <Button on:click={() => modalStore.open('account', 'modal', account)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
